import React, { useEffect, useState } from 'react'
import TableComponent from "../CustomComponents/TableComponent";
import PageHeader from '../../view/pageheader';
import { Card, Tabs } from 'antd';
import { excelUploadData } from '../../store/reducer/prepQueueSlice';
import { wareHouseExcelUploadData, hardDiskExcelUploadData, dispositionExcelUploadData } from '../../store/reducer/wearehouseSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { NODELOCALASSETURL } from '../../services/config'
import { useLocation } from 'react-router-dom';
import moment from "moment-timezone";

const { TabPane } = Tabs;
const PreprocessingUploadLogs = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { excelUploadDatas } = useSelector((state) => state.prepTeamQueue);
    const { wareHouseExcelUploadDatas, hardDiskExcelUploadDatas, dispositionExcelUploadDatas } = useSelector((state) => state.wearehouse)
    const [activeTab, setActiveTab] = useState("preprocess");
    const { count: preprocessCount, data: preprocessTable } = excelUploadDatas || {};
    const { count: warehouseCount, data: warehouseTable } = wareHouseExcelUploadDatas || {};
    const { cout: hardDiskCount, data: hardDiskTable } = hardDiskExcelUploadDatas || {}
    const { count: dispostioncount, data: dispositionTable } = dispositionExcelUploadDatas || {}
    const userId = localStorage.getItem("user_id");
    function getData(payload = {}) {
        if (activeTab === "preprocess") {
            dispatch(excelUploadData({ ...payload, userId }));
        } else if (activeTab == "hard-disk") {
            dispatch(hardDiskExcelUploadData({ ...payload }));
        } else if (activeTab == "disposition") {
            dispatch(dispositionExcelUploadData({ ...payload }))
        }
        else {
            dispatch(wareHouseExcelUploadData({ ...payload, userId }));
        }
    }

    // Run on tab change
    useEffect(() => {
        getData({});
    }, [dispatch, activeTab]);
    useEffect(() => {
        if (location.state?.activeTab) {
            setActiveTab(location.state.activeTab);
        }
    }, [location.state]);

    const columns = [
        // ...(activeTab === "preprocess" ? [
        //     {
        //         title: "Sl.No",
        //         dataIndex: "preprocess_id",
        //         key: "preprocess_id",
        //         align: "center",
        //         render: (text) => text || "-", // shows preprocess_id in the table
        //     },
        // ] : []),

        {
            title: "Uploaded Date",
            dataIndex: "created_at",
            key: "created_at",
            render: (created_at) =>
                moment(created_at).tz("America/New_York").format("MM-DD-YYYY hh:mm A"),
            align: "center",

        },


        {
            title: "File Name",
            dataIndex: "file_name",
            key: "file_name",
            align: "center",
            render: (text, record) => (
                <Link to={`${NODELOCALASSETURL}${record.file_path}`} target="_blank" rel="noopener noreferrer">
                    {text}
                </Link>
            ),
        },
        {
            title: "Total Records",
            dataIndex: "total_records",
            key: "total_records",
            align: "center",
            sorter: true,

        },
        {
            title: 'Accepted Records',
            dataIndex: "accepted_records",
            key: "accepted_records",
            align: "center",
            // sorter: (a, b) => a.customername.localeCompare(b.customername),
        },
        {
            title: "Rejected Records",
            dataIndex: "rejected_records",
            key: "failed_records",
            align: "center",
            // sorter: (a, b) => a.customername.localeCompare(b.customername),
        }];
    const items = [
        {
            label: "Add Box to Spec Logs",
            key: "preprocess",
            children: (
                <TableComponent
                    columns={columns}
                    TotalDataCount={preprocessCount}
                    dataSource={preprocessTable}
                    size="small"
                    onChangeDispatch={getData}
                />
            ),
        },
        {
            label: "Review & Assign Spec Logs",
            key: "warehouse",
            children: (
                <TableComponent
                    columns={columns}
                    TotalDataCount={warehouseCount}
                    dataSource={warehouseTable}
                    size="small"
                    onChangeDispatch={getData}
                />
            ),
        },
        {
            label: "Update Hard Drive Logs",
            key: "hard-disk",
            children: (
                <TableComponent
                    columns={columns}
                    TotalDataCount={hardDiskCount}
                    dataSource={hardDiskTable}
                    size="small"
                    onChangeDispatch={getData}
                />
            ),
        },
        {
            label: "Disposition Logs",
            key: "disposition",
            children: (
                <TableComponent
                    columns={columns}
                    TotalDataCount={dispostioncount}
                    dataSource={dispositionTable}
                    size="small"
                    onChangeDispatch={getData}
                />
            ),
        },
    ];
    return (
        <>
            <PageHeader HeaderText="Excel Upload Logs" backButtonUrl="" backgroundUrlName={true} />
            <Card style={{ marginTop: "-28px", }}>
                <Tabs
                    activeKey={activeTab}
                    onChange={(key) => setActiveTab(key)}
                    items={items} // Use the items prop instead of TabPane
                />
            </Card>
        </>
    );
};

export default PreprocessingUploadLogs